import { Checkbox, FormControlLabel, Paper, Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { HomeFeature } from "../../app/stores/homeFeatureVisibilityStore";
import { useStore } from "../../app/stores/store";



function HomeFeatureVisibilityControl() {
  const { toggleVisibleItem, visibleItem } = useStore().homeFeatureVisibilityStore

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    toggleVisibleItem(Number(event.target.name))
  }
  
  const checkboxes = [
    {
      name: HomeFeature.TrendChart,
      checked: visibleItem.includes(HomeFeature.TrendChart),
      label: 'Trend Chart'
    },
    {
      name: HomeFeature.AutomationRecommendation,
      checked: visibleItem.includes(HomeFeature.AutomationRecommendation),
      label: 'Automation Recommendation'
    },
    {
      name: HomeFeature.TableEquipment,
      checked: visibleItem.includes(HomeFeature.TableEquipment),
      label: 'Table Equipment'
    },
  ]
  
  return (
    <Stack direction="row" padding={2} justifyContent="space-evenly" component={Paper}>
      {checkboxes.map((checkbox, index) => (
        <FormControlLabel 
          key={index}
          control={
            <Checkbox 
              onChange={handleChange}
              name={String(checkbox.name)}
              checked={checkbox.checked}
            />
          } 
          label={checkbox.label} 
        />
      ))}
    </Stack>
  )
}

export default observer(HomeFeatureVisibilityControl)